export default __webpack_public_path__ + "static/media/img4.844818a8.jpg";